import { render, staticRenderFns } from "./GalleryInfo.vue?vue&type=template&id=35892f85&scoped=true"
import script from "./GalleryInfo.vue?vue&type=script&lang=js"
export * from "./GalleryInfo.vue?vue&type=script&lang=js"
import style0 from "./GalleryInfo.vue?vue&type=style&index=0&id=35892f85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35892f85",
  null
  
)

export default component.exports